import $ from 'jquery';

require('leaflet');
require('leaflet-providers');
require('leaflet-control-geocoder');

/**
 * @type {L.Control.Geocoder.Nominatim}
 */
const geocoder = L.Control.Geocoder.nominatim({
    geocodingQueryParams: { 'accept-language': 'el' },
    reverseQueryParams: { 'accept-language': 'el' },
});

/**
 *
 * @param {JQuery} $coordinatesInput
 * @param {JQuery} $addressInput
 * @param {L.Marker} marker
 * @param {L.Control.Geocoder.Nominatim} geocoder
 */
const clickOnMap = ($coordinatesInput, $addressInput, marker, geocoder) => {
    return (e) => {
        marker.setLatLng(e.latlng);
        updateLocation($coordinatesInput, marker, geocoder);
        reverseGeocoding(geocoder, e.latlng, $addressInput);
    };
};

/**
 *
 * @param {JQuery} $addressInput
 * @param {object} result
 */
const updateAddress = ($addressInput, result) => {
    $addressInput.val(result.name);
};

/**
 * @param {JQuery} $coordinatesInput
 * @param {L.Marker} marker
 */
const updateLocation = ($coordinatesInput, marker) => {
    let latlng = marker.getLatLng();

    $coordinatesInput.val(`${ latlng.lat },${ latlng.lng }`);
};

/**
 *
 * @param {L.Control.Geocoder.Nominatim} geocoder
 * @param {L.LatLng} latlng
 * @param {JQuery} $addressInput
 */
const reverseGeocoding = (geocoder, latlng, $addressInput) => {
    geocoder.reverse(latlng, 6, (results) => {
        console.log('reverse', results);

        if (results.length) {
            updateAddress($addressInput, results[0]);
        } else {
            updateAddress($addressInput, { name: '' });
        }
    });
};

$(function() {
    if (($("#locationAddress").length > 0) && ($("#locationCoordinates").length > 0) && ($("#locationMap").length > 0)) {
        InitMap($("#locationAddress"), $("#locationCoordinates"), $("#locationMap"), "locationMap");
    }
    if (($("#locationDeparture").length > 0) && ($("#departureCoordinates").length > 0) && ($("#departureMap").length > 0)) {
        InitMap($("#locationDeparture"), $("#departureCoordinates"), $("#departureMap"), "departureMap");
    }
    if (($("#locationTour").length > 0) && ($("#tourCoordinates").length > 0) && ($("#tourMap").length > 0)) {
        InitMap($("#locationTour"), $("#tourCoordinates"), $("#tourMap"), "tourMap");
    }
    if (($("#locationVacation").length > 0) && ($("#vacationCoordinates").length > 0) && ($("#vacationMap").length > 0)) {
        InitMap($("#locationVacation"), $("#vacationCoordinates"), $("#vacationMap"), "vacationMap");
    }
    if (($("#locationStop").length > 0) && ($("#stopCoordinates").length > 0) && ($("#stopMap").length > 0)) {
        InitMap($("#locationStop"), $("#stopCoordinates"), $("#stopMap"), "stopMap");
    }
    if (($("#locationArrival").length > 0) && ($("#arrivalCoordinates").length > 0) && ($("#arrivalMap").length > 0)) {
        InitMap($("#locationArrival"), $("#arrivalCoordinates"), $("#arrivalMap"), "arrivalMap");
    }
});

function InitMap(location, locationCoordinates, map, mapName) {
    var $addressInput = location;
    var $locationMap = map;
    var $locationCoordinates = locationCoordinates;
    var $locationMapName = mapName;

    let coordinates = [40.0, 24.0];

    if ($locationMap.length) {
        if ($locationCoordinates.val()) {
            coordinates = $locationCoordinates.val().split(',');
        }

        /**
         * @type {L.Marker}
         */
        const startingPointMarker = L.marker(coordinates, { draggable: true });

        /**
         * @type {L.Map}
         */
        const locationMap = L.map($locationMapName)
            .on('load', () => updateLocation($locationCoordinates, startingPointMarker))
            .setView(coordinates, 5)
            .setMinZoom(6);

        L.tileLayer.provider('OpenStreetMap').addTo(locationMap);

        startingPointMarker.addTo(locationMap);
        startingPointMarker.on('moveend', (e) => {
            updateLocation($locationCoordinates, startingPointMarker);
            reverseGeocoding(geocoder, startingPointMarker.getLatLng(), $addressInput);
        });

        /**
         * Change marker location.
         */
        locationMap.on('click', _.throttle(clickOnMap($locationCoordinates, $addressInput, startingPointMarker, geocoder), 1000));

        /**
         * Add geocoder.
         */
        L.Control.geocoder({
            defaultMarkGeocode: false,
            geocoder: geocoder,
            placeholder: 'Αναζήτηση',
        }).on('markgeocode', (e) => {
            startingPointMarker.setLatLng(e.geocode.center);
            locationMap.fitBounds(e.geocode.bbox);
            updateAddress($addressInput, e.geocode);
        }).addTo(locationMap);
    }
}